import { SVGProps, Ref, forwardRef } from 'react';

export const PinCrossedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m11.421 8.421 1.887-1.887 1.202 1.202.99-.99L9.25.496l-.99.99 1.202 1.202-1.887 1.887.99.99 1.887-1.887 1.866 1.866-1.887 1.887z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m1.5.5-1 1 4.25 4.25a4.08 4.08 0 0 0-3.361 1.165l-.722.722 3.354 3.355L.5 14.5l1 1 3.51-3.518L8.36 15.33l.721-.722a4.08 4.08 0 0 0 1.167-3.361L14.5 15.5l1-1zm7.098 9.098-2.2-2.2-1.747-.25a2.68 2.68 0 0 0-1.985.509L8.34 13.33a2.68 2.68 0 0 0 .508-1.986z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PinCrossedOutlinedSize16Glyph.displayName = 'PinCrossedOutlinedSize16Glyph';
